<template>
    <div ref="chartdiv" class="chart" :style="{ width: props.width, height: props.height }"></div>
</template>

<script setup>
import { onMounted, onUnmounted, ref, defineProps } from 'vue';
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';

const chartdiv = ref(null);
const props = defineProps({
    chartData: { default: null },
    width: { default: '100%' },
    height: { default: '100%' },
    chartFontSizeData: { default: null },
});
let root;
onMounted(() => {
    //2023-01-01 pby 재반영 확인
    if (props.chartData && props.chartData.length > 0) {
        root = am5.Root.new(chartdiv?.value);

        let chart = root.container.children.push(
            am5xy.XYChart.new(root, {
                paddingTop: 40,
                layout: root.verticalLayout,
            }),
        );
        //2023-01-01 pby 재반영 확인
        let data = props.chartData;
        //2023-01-01 pby 재반영 확인
        let yAxis = chart.yAxes.push(
            am5xy.ValueAxis.new(root, {
                min: 0,
                max: 100,
                numberFormat: "#'%'",
                renderer: am5xy.AxisRendererY.new(root, { minGridDistance: 80 }),
            }),
        );
        //2023-01-01 pby 재반영 확인
        let xAxis = chart.xAxes.push(
            am5xy.CategoryAxis.new(root, {
                renderer: am5xy.AxisRendererX.new(root, { minGridDistance: 10 }),
                categoryField: 'category',
                tooltip: am5.Tooltip.new(root, {}),
            }),
        );
        //2023-01-01 pby 재반영 확인
        xAxis.get('renderer').labels.template.setAll({
            fontSize: props.chartFontSizeData ? props.chartFontSizeData.xAxis : '2.4vmin',
            fontWeight: 550,
            fill: '#222',
        });
        //2023-01-01 pby 재반영 확인
        yAxis.get('renderer').labels.template.setAll({
            fontSize: props.chartFontSizeData ? props.chartFontSizeData.yAxis : '2.7vmin',
            fontWeight: 550,
            fill: '#222',
        });

        xAxis.data.setAll(data);
        //2023-01-01 pby 재반영 확인
        let series1 = chart.series.push(
            am5xy.ColumnSeries.new(root, {
                name: 'Series',
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: 'value1',
                categoryXField: 'category',
                maskBullets: false,
                fill: 'red',
            }),
        );
        //2023-01-01 pby 재반영 확인
        series1.columns.template.setAll({
            fillOpacity: 0.5,
            strokeWidth: 2,
            width: 30,
            cornerRadiusTL: 30,
            cornerRadiusTR: 30,
        });
        //2023-01-01 pby 재반영 확인
        series1.columns.template.adapters.add('fill', (fill, target) => {
            var value = target.dataItem.dataContext.value1;

            if (value < 50) {
                fill = '#A0A0A0';
            } else if (value >= 50 && value < 80) {
                fill = '#bee8c9';
            } else {
                fill = '#18b73f';
            }
            return fill;
        });
        //2023-01-01 pby 재반영 확인
        series1.columns.template.adapters.add('stroke', (stroke, target) => {
            var value = target.dataItem.dataContext.value1;

            if (value < 50) {
                stroke = '#A0A0A0';
            } else if (value >= 50 && value < 80) {
                stroke = '#bee8c9';
            } else {
                stroke = '#18b73f';
            }
            return stroke;
        });
        //2023-01-01 pby 재반영 확인
        series1.data.setAll(data);

        var tooltip = am5.Tooltip.new(root, {
            getFillFromSprite: false,
            getStrokeFromSprite: true,
            autoTextColor: false,
            getLabelFillFromSprite: true,
            labelText: '{valueY}%',
            fontSize: '1.2vmin',
        });
        //2023-01-01 pby 재반영 확인
        tooltip.get('background').setAll({
            fill: 'white',
            fillOpacity: 0.8,
        });
        //2023-01-01 pby 재반영 확인
        series1.set('tooltip', tooltip);
        series1.bullets.push(function () {
            return am5.Bullet.new(root, {
                locationY: 1.0,
                sprite: am5.Label.new(root, {
                    text: "[fontWeight:700]{valueYWorking.formatNumber('#.')}%",
                    centerY: am5.p100,
                    centerX: am5.p50,
                    populateText: true,
                    fill: 'black',
                    fontSize: props.chartFontSizeData ? props.chartFontSizeData.percentNum : '2.4vmin',
                }),
            });
        });
        //2023-01-01 pby 재반영 확인
        series1.appear(2000);
        chart.appear(1000, 100);
    }
});

onUnmounted(() => {
    root.dispose();
});
</script>
<style lang="scss" scoped>
@media print {
    .chart {
        ::v-deep > div {
            display: flex;
            justify-content: center;
        }
        ::v-deep canvas {
            width: 100% !important;
            height: 100% !important;
            top: 50% !important;
            left: 50% !important;
            transform: translate(-50%, -50%);
        }
    }
}
</style>
